import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import * as myGlobals from '../../globals';
import 'rxjs/Rx';
import { ConfigService } from '../../config.service';

export class User {
    constructor() { }
}

@Injectable()
export class AccountService {

    private _updateprofile = myGlobals.apiurl + 'profile/me';
    private _checkprofile = myGlobals.apiurl + 'profile/me';
    private _checkpassword = myGlobals.apiurl + 'checkpassword';

    // START OF UBER FOR ALL API CALLS
    private _changeEmail = myGlobals.apiurl + 'customer/email';
    private _changePassword = myGlobals.apiurl + 'customer/password/me';
    private _changePhonenum = myGlobals.apiurl + 'customer/phoneNumber';
    private _changeFirstName = myGlobals.apiurl + 'customer/profile';
    private _checkPhone = myGlobals.apiurl + 'customer/phoneValidation';
    // END OF UBER FOR ALL API CALLS

    constructor(
        private _router: Router,
        private _http: Http,
        private _cookie: ConfigService
    ) { }

    // START OF UBER FOR ALL FUNCTIONS

    // change email
    changeEmail(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changeEmail, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // change password
    changePassword(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changePassword, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // change password
    changePhoneNum(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changePhonenum, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // change first name
    changeFirstName(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.patch(this._changeFirstName, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // END OF UBER FOR ALL FUNCTIONS

    // PROFILE CHANGING CALL 
    updateprofile(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.put(this._updateprofile, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // CHECK PASSWORD CALL 
    checkpassword(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.post(this._checkpassword, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }

    // CHECK PHONENUMBER CALL 
    checkPhone(user: any) {
        console.log(user);
        let body = JSON.stringify(user);
        return this._http.post(this._checkPhone, body, { headers: this._cookie.header })
            .map(res => res.json())
            .map((res) => {
                return res;
            })
    }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/account/account.service.ts